/**
 * functions that emulates the classic behaviour of the String.Format
 * @param text the text to format
 * @param params the params to replace
 */
export function stringFormat(text: string, ...params: string[]): string {
  for (let i = 0; i < params.length; i++) {
    text = text.replace(new RegExp('\\{' + i + '\\}', 'g'), params[i])
  }
  return text
}
